
var pageMain = (function () {
    var init, particle, motion;

    init = function () {

        if( $('body').hasClass('web') ){
            particle();
        }

        motion();
    };

    particle = function () {
        particlesJS("particles-js", {
            "particles": {
                "number": {//점 개수 설정
                    "value": 30,//점 갯수
                    "density": {
                        "enable": true,// 점 밀집도 변경 여부
                        "value_area": 800//밀집도
                    }
                },
                "color": {//점 색상
                    "value": "#ffffff"
                },
                "shape": {
                    "type": "circle",//점 모양
                    // circle:원, edge:사각, triangle:삼각, polygon:다각형, star:별형, image:이미지
                    "stroke": {
                        "width": 0,//외곽선 굵기(선없음)
                        "color": "#ffffff"
                    },
                    "polygon": {// type을 polygon으로 했을 때 설정
                        "nb_sides": 5// 꼭지점 수
                    },
                    "image": {// type을 이미지로 했을 때 설정
                        "src": "https://op-wstatic.ncsoft.com/promo/bns/event/2020/200527_celestial/img/aa.png",
                        "width": 32,
                        "height": 40
                    }
                },
                "opacity": {// 투명도
                    "value": 0.4,
                    "random": true, // 투명도 랜덤하게 여부
                    "anim": {
                        "enable": true,// 투명성을 애니메이션시키느냐
                        "speed": 0.2,//애니메이션의 속도
                        "opacity_min": 0,//투명도의 최소치
                        "sync": false //모든 점을 동시에 애니메이션시키느냐
                    }
                },
                "size": {
                    "value": 4,// 점 크기
                    "random": true,// 점 크기 랜덤 여부
                    "anim": {// 크기 애니메이션 화 설정
                        "enable": false,
                        "speed": 12,
                        "size_min": 0,
                        "sync": false
                    }
                },
                "line_linked": {// 점의 연결선 설정
                    "enable": false,// 선 표시 여부
                    "distance": 500,//선을 잇는 셰이프의 간격
                    "color": "#ffffff",//선 색
                    "opacity": 0.4,//선의 투명도
                    "width": 2//선의 굵기
                },
                "move": {// 움직임 설정
                    "enable": true,// 움직임 여부
                    "speed": 1.5,//속도
                    "direction": "none",// 움직임 방향 (none, top, top-right, right, bottom-right, bottom, bottom-left, left, top-left)
                    "random": false,
                    "straight": false,// 개별 모양의 움직임 멈춤 여부
                    "out_mode": "out",// 영역 밖에 나온 점 움직임(out, bounce)
                    "bounce": false,
                    "attract": {
                        "enable": false,
                        "rotateX": 600,
                        "rotateY": 1200
                    }
                }
            },
            "interactivity": {// 인터렉티브 설정
                "detect_on": "canvas",
                "events": {
                    "onhover": {
                        "enable": false,// 마우스 오버가 유효한지 여부
                        "mode": "bubble"// 마우스 오버시 반응 움직임(grab, repulse, bubble)
                    },
                    "onclick": {
                        "enable": false,// 마우스 오버가 유효한지 여부
                        "mode": "repulse"
                    },
                    "resize": true
                },
                "modes": {// 움직임 설정
                    "grab": {// 커서와 점사이 선이 표시됨
                        "distance": 400,
                        "line_linked": {//커서의 반응 거리
                            "opacity": 0.5//선의 투명도
                        }
                    },
                    "bubble": {// 점이 커짐
                        "distance": 400,//커서의 반응 거리
                        "size": 4,// 커지는 크기
                        "duration": 0.3,// 늘어날 셰이프의 지속 시간(onclick시만)
                        "opacity": 0.5,// 늘어날 셰이프의 투명도
                        "speed": 3// 늘어날 셰이프의 속도(onclick시만)
                    },
                    "repulse": {// 점이 커서를 피해 퍼짐
                        "distance": 200,//커서의 반응 거리
                        "duration": 0.4
                    },
                    "push": {// 점 갯수가 늘어남
                        "particles_nb": 4// 늘어날 점 갯수
                    },
                    "remove": {// 점 갯수가 줄어듬
                        "particles_nb": 2// 줄어들 점 갯수
                    }
                }
            },
            "retina_detect": false,//레티나 디스플레이에 대응
        });
    };

    motion = function() {

        // TweenMax.fromTo('.space--bg', 1, {alpha:0, y:-80, scale:0.8}, {alpha:1, y:0, scale:1});
        // TweenMax.to('.character', 1.5, {duration: 5, y: 4, repeat: -1, yoyo: true});

        // TweenMax.to('.star--01', 1.5, {duration: 3, autoAlpha:0.5, repeat: -1, yoyo: true})
        // TweenMax.to('.star--02', 1, {duration: 5, autoAlpha:0.8, repeat: -1, yoyo: true})
        // TweenMax.to('.star--03', 1.5, {duration: 1, autoAlpha:0.5, repeat: -1, yoyo: true})
        // TweenMax.to('.star--04', 1, {duration: 3, autoAlpha:0.3, repeat: -1, yoyo: true})
        // TweenMax.to('.star--05', 0.8, {duration: 5, autoAlpha:0.8, repeat: -1, yoyo: true})
        // TweenMax.to('.star--06', 1, {duration: 1, autoAlpha:0.5, repeat: -1, yoyo: true})
        // TweenMax.to('.star--07', 1.5, {duration: 3, autoAlpha:0.2, repeat: -1, yoyo: true})
        // TweenMax.to('.star--08', 1, {duration: 5, autoAlpha:0.8, repeat: -1, yoyo: true})

        new TimelineMax()
            .addLabel('start')
            .fromTo('.space--bg', 10, {alpha:0}, {alpha:1, ease: Power1.easeOut })
            .fromTo('.character', 1.5, {alpha:0, x:-20, y:20}, {alpha:1, x:0, y:0, ease: Power1.easeIn }, 'start+=1.0')

            .fromTo('.star--01', 0.8, {alpha:0, scale:0.5, y:+20}, { alpha:1, y:0,  scale:1, ease: Power1.easeOut}, 'start+=1.4')
            .fromTo('.star--02', 0.2, {alpha:0, scale:0.5, y:+20}, { alpha:1, y:0,  scale:1, ease: Power1.easeOut}, 'start+=1.4')
            .fromTo('.star--03', .7, {alpha:0, scale:0.8, y:+10}, {alpha:1, y:0,  scale:1, ease: Power1.easeOut}, 'start+=1.4')
            .fromTo('.star--04', .5, {alpha:0, scale:0.8, y:+10}, {alpha:1, y:0,  scale:1, ease: Power1.easeOut}, 'start+=1.4')

            .fromTo('.star--05', 0.7, {alpha:0, scale:0, y:+40}, {alpha:1, y:0,  scale:1, ease: Power1.easeOut}, 'start+=1.4')
            .fromTo('.star--06', 0.5, {alpha:0, scale:0, y:+40}, {alpha:1, y:0,  scale:1, ease: Power1.easeOut}, 'start+=1.4')
            .fromTo('.star--07', .2, {alpha:0, scale:0.2, y:+55}, { alpha:1, y:0,  scale:1, ease: Power1.easeOut}, 'start+=1.4')
            .fromTo('.star--08', .6, {alpha:0, scale:0.2, y:+55}, { alpha:1, y:0,  scale:1, ease: Power1.easeOut}, 'start+=1.4')

            .fromTo('.title--01', 1,{autoAlpha:0, scale:1, y:+20},{autoAlpha:1, scale:1, y:0, ease: Power1.easeOut},'start+=.5')
            .fromTo('.title--02', 1,{autoAlpha:0, scale:1, y:+20},{autoAlpha:1, scale:1, y:0, ease: Power1.easeOut},'start+=.7')
            .fromTo('.title--03', 1,{autoAlpha:0, scale:1, y:+20},{autoAlpha:1, scale:1, y:0, ease: Power1.easeOut},'start+=1.0')
            .fromTo('.title--04', 1, { alpha:0}, {alpha:1,  ease: Power1.easeOut}, 'start+=1.8')

            // .staggerFromTo($(".title--text"), 1,{y:50, scale:0.8, alpha:0}, {y:0, scale:1, alpha:1, ease:Back.easeOut.config(3)}, 0.2)

            .fromTo($('.btn__floating'), 1, { y: 80, opacity: 0 }, { y: 20, opacity: 1, ease: Power3.easeOut },'start+=2.5')
            // .add(TweenMax.to('.space--ball', 1.5, {duration: 15, alpha: 0.8, repeat: -1, yoyo: true}))



        //
        //
        //     TweenMax.to('.star--02', 1.5, {duration: 3, autoAlpha:0.5, repeat: -1, yoyo: true})
        //     TweenMax.to('.star--03', 1.5, {duration: 3, autoAlpha:0.5, repeat: -1, yoyo: true})
        //     TweenMax.to('.star--04', 1.5, {duration: 3, autoAlpha:0.5, repeat: -1, yoyo: true})
        //
        // tlStar
        //     .add(TweenMax.to('.star--02', 1.5, {duration: 3, autoAlpha: 0.5, repeat: -1, yoyo: true}))
        //         .to('.star--02', 1.5, {duration: 3, autoAlpha:0.5, repeat: -1, yoyo: true})
        //         .to('.star--02', 1.5, {duration: 3, autoAlpha:0.5, repeat: -1, yoyo: true})
        //         .to('.star--02', 1.5, {duration: 3, autoAlpha:0.5, repeat: -1, yoyo: true})
        //         .to('.star--02', 1.5, {duration: 3, autoAlpha:0.5, repeat: -1, yoyo: true})
        // }
    }

    return {
        init: init
    }
})();

// pageMain.init();
promokit.footer = false;
promokit.preload({
    complete: function() {
        pageMain.init();
    }
});



// WEBPACK FOOTER //
// ./src/js/index.js